import { LoaderFunction } from '@remix-run/node';

export const buildLegalLoader = (name: string): LoaderFunction => {
  return (args: any) => {
    const {
      context: { loaders, setRemixParams },
      params,
    } = args;

    setRemixParams(params);
    return loaders[name]();
  };
};
